import * as actionTypes from "../actions/actionTypes";

const inviteParticipantState = {
  inviteParticipantLoading: false,
  inviteParticipantSuccess: {},
  inviteParticipantError: null,
};

export const defaultState = {
  loading: false,
  data: null,
  error: null,
  ...inviteParticipantState,
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actionTypes.GET_VIDEO_CALL_TOKEN_START:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case actionTypes.GET_VIDEO_CALL_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionTypes.GET_VIDEO_CALL_TOKEN_ERROR:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    case actionTypes.INVITE_PARTICIPANT_START:
      return {
        ...state,
        inviteParticipantLoading: true,
        inviteParticipantSuccess: {},
        inviteParticipantError: null,
      };
    case actionTypes.INVITE_PARTICIPANT_SUCCESS:
      return {
        ...state,
        inviteParticipantLoading: false,
        inviteParticipantSuccess: action.payload,
        inviteParticipantError: null,
      };
    case actionTypes.INVITE_PARTICIPANT_ERROR:
      return {
        ...state,
        inviteParticipantLoading: false,
        inviteParticipantSuccess: {},
        inviteParticipantError: action.payload,
      };
    default:
      return state;
  }
};
